import { c as _c } from "react/compiler-runtime";
import { AccountSelector as NovaAccountSelector, type SelectedAccount } from '@newfront-insurance/nova-core';
import { useEffect, useMemo, useState } from 'react';
import { useChatOverlayContext } from '../../contexts/chat-overlay-context';
interface AccountSelectorProps {
  className?: string;
  width?: number;
  placeholder?: string;
}

/**
 * Component for displaying and selecting the current account.
 * Uses chat overlay context to access account state.
 * Mimics the behavior from the old chat overlay:
 * - Shows selector for new chats when feature flag is enabled
 * - Shows selector for existing chats when no account is set (allows setting account after chat creation)
 * - Shows account name when account is set
 * - Updates account context when account is selected
 * - Triggers GraphQL mutation when account is selected after messages have been sent
 */
export function AccountSelector(t0) {
  const $ = _c(25);
  const {
    className,
    width,
    placeholder
  } = t0;
  const {
    accountUuid,
    accountName,
    selectedAccount: contextSelectedAccount,
    onSelectAccount,
    queryAccountUuid,
    isStandaloneMode,
    displayAccount,
    userUuid,
    userScopes,
    hasAnyMessages
  } = useChatOverlayContext();
  const [selectedAccount, setSelectedAccount] = useState(contextSelectedAccount);
  let t1;
  let t2;
  if ($[0] !== accountName || $[1] !== accountUuid || $[2] !== displayAccount) {
    t2 = displayAccount ?? (accountUuid && accountName ? {
      uuid: accountUuid,
      name: accountName
    } : null);
    $[0] = accountName;
    $[1] = accountUuid;
    $[2] = displayAccount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  t1 = t2;
  const accountToDisplay = t1;
  accountToDisplay?.uuid;
  selectedAccount?.uuid;
  const isAccountLocked = (() => {
    const hasAccountContext = Boolean(accountToDisplay?.uuid);
    const hasSelectedAccount = Boolean(selectedAccount?.uuid);
    return hasAnyMessages && (hasAccountContext || hasSelectedAccount);
  })();
  let t3;
  bb0: {
    if (isStandaloneMode) {
      t3 = !isAccountLocked;
      break bb0;
    }
    if (queryAccountUuid) {
      t3 = false;
      break bb0;
    }
    t3 = !isAccountLocked;
  }
  const shouldShowAccountSelector = t3;
  let t4;
  let t5;
  if ($[4] !== shouldShowAccountSelector) {
    t4 = () => {
      if (!shouldShowAccountSelector) {
        setSelectedAccount(undefined);
      }
    };
    t5 = [shouldShowAccountSelector];
    $[4] = shouldShowAccountSelector;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== onSelectAccount) {
    t6 = account => {
      setSelectedAccount(account);
      onSelectAccount(account);
    };
    $[7] = onSelectAccount;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleAccountSelect = t6;
  if (shouldShowAccountSelector && userUuid && userScopes) {
    let t7;
    if ($[9] !== handleAccountSelect || $[10] !== placeholder || $[11] !== selectedAccount || $[12] !== userScopes || $[13] !== userUuid || $[14] !== width) {
      t7 = <NovaAccountSelector width={width} selectedAccount={selectedAccount} onSelectAccount={handleAccountSelect} loggedInUserUuid={userUuid} userScopes={userScopes} placeholder={placeholder} />;
      $[9] = handleAccountSelect;
      $[10] = placeholder;
      $[11] = selectedAccount;
      $[12] = userScopes;
      $[13] = userUuid;
      $[14] = width;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== className || $[17] !== t7) {
      t8 = <div className={className}>{t7}</div>;
      $[16] = className;
      $[17] = t7;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    return t8;
  }
  const displayName = accountToDisplay?.name ?? selectedAccount?.label;
  if (displayName) {
    let t7;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <span className="font-semibold">Account</span>;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    let t8;
    if ($[20] !== displayName) {
      t8 = <span className="text-muted-foreground text-sm">{t7}: {displayName}</span>;
      $[20] = displayName;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    let t9;
    if ($[22] !== className || $[23] !== t8) {
      t9 = <div className={className}>{t8}</div>;
      $[22] = className;
      $[23] = t8;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    return t9;
  }
}